/**
 * TODO: Use the `genUID` function from `@frontend/design-system` after the DS package is refactored.
 * Duplicating the code here to avoid importing a UI module in the service module.
 * This is needed to prevent unit tests from breaking by importing UI components from the DS (for now).
 */
export function genAlphaNumeric(): string {
  return Math.floor((1 + Math.random()) * 0x1000000)
    .toString(16)
    .substring(1);
}

/**
 * Generate a new unique ID with a hyphen.
 * The ID consists of two parts, each with 6 alphanumeric characters.
 */
export function genUID(): string {
  return genAlphaNumeric() + '-' + genAlphaNumeric();
}

/**
 * Get the prefix for the default category UUID.
 */
export function getPrefixForDefaultCategoryUUID(): string {
  return 'defcat';
}

/**
 * Generate a new default category ID for the categorized options field.
 */
export function genUUIDForDefaultCategory() {
  return `${getPrefixForDefaultCategoryUUID()}-${genAlphaNumeric()}`;
}
